/**
 * Force a cache-busting page reload.
 *
 * On iOS Capacitor WebView, `window.location.reload()` may serve a cached
 * `index.html` that references stale JS chunk filenames (which no longer
 * exist after a deployment).  By navigating to the origin with a unique
 * query-string parameter we force the WebView to fetch a fresh copy of
 * every resource.
 */
export function hardReload(): void {
  const url = new URL(window.location.href);
  url.searchParams.set('_cb', Date.now().toString());
  window.location.replace(url.toString());
}
